import { ExclamationTriangleIcon, InfoCircledIcon } from '@radix-ui/react-icons';
import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { TONE_INK, TONE_SURFACE } from './tone';

/**
 * A standing note about the data on screen, e.g. a suspicious flag. `role="note"`, not `alert`:
 * it's present on load and shouldn't interrupt a screen reader.
 */
export function Callout({
  tone = 'info',
  title,
  children,
  action,
  className,
}: {
  tone?: 'info' | 'warning';
  title: string;
  children?: ReactNode;
  action?: ReactNode;
  className?: string;
}) {
  const Icon = tone === 'warning' ? ExclamationTriangleIcon : InfoCircledIcon;
  return (
    <div role="note" className={cn('flex gap-3 rounded-lg border px-4 py-3 text-sm', TONE_SURFACE[tone], className)}>
      <Icon aria-hidden className={cn('mt-0.5 size-4 shrink-0', TONE_INK[tone])} />
      <div className="min-w-0 flex-1 space-y-1">
        <p className="font-medium">{title}</p>
        {children && <div className="text-muted-foreground">{children}</div>}
      </div>
      {action && <div className="shrink-0 self-center">{action}</div>}
    </div>
  );
}
